import 'angular';

import '../../app-lite/myob/myob.module.ajs';

import { MYOBCompanyFileCtrl }     from './myob.company-file';
import { MYOBStates }              from './myob.states.ajs';
import { MYOBSettingsCtrl }        from './myob.settings';
import { SyncMyobCompanyFileCtrl } from './myob.sync-company-file';

angular.module('workshop.myob', [
  'app-lite.myob'
])
.config(MYOBStates)
.controller('MYOBCompanyFileCtrl', MYOBCompanyFileCtrl)
.controller('MYOBSettingsCtrl', MYOBSettingsCtrl)
.controller('SyncMyobCompanyFileCtrl',  SyncMyobCompanyFileCtrl);
